import React, { useState } from 'react';

import Header from '../components/Header';
import Second from '../components/Second';
import Third from '../components/Third';
import AdvertSection from '../components/VipAdvert';
// import Advert from '../components/Advert';
import MobileBottomBar from '../components/MobileBottomBar';
import MobileAppModal from '../../modals/mobile_app_modal/ui/Main';

// import NewsModal from '../../modals/news/ui/Main';

import { I18nextProvider } from 'react-i18next';
import i18n from '../../../language/i18n';

import usePageTracking from '../../../features/analytics/usePageTracking';
import { useSEO } from '../../../hooks/useSEO';

function Main() {
    usePageTracking();
    useSEO({
        title: 'Ауыл шаруашылығы тауарлары — Agroland.kz',
        description: 'Қазақстандағы ауыл шаруашылығы тауарларын сатып алу және сатуға арналған онлайн нарық. Техника, құрал-жабдықтар, тұқым, тыңайтқыштар және басқа да агро өнімдер.',
        keywords: 'ауыл шаруашылығы, агро, техника, құрал-жабдықтар, тұқым, тыңайтқыш, Қазақстан, сатып алу, сату',
        ogType: 'website'
    }, []);
    const [bottomBarHidden, setBottomBarHidden] = useState(false);

    const handleBottomBarToggle = (isHidden) => {
        setBottomBarHidden(isHidden);
    };

    return (
        <I18nextProvider i18n={i18n}>
            <Header onToggleMenu={handleBottomBarToggle} />
            <Second />
            <Third />
            <AdvertSection />
            {/* <Advert /> */}
            {!bottomBarHidden && <MobileBottomBar activeTabName={'home'} />}
            <MobileAppModal />
            {/* <NewsModal menuVisible={true}/> */}
        </I18nextProvider>
    );
}

export default Main;